<template>
  <div>
    <Card style="height:40px;">
      <Row>
        <i-col :span="10">
          <Input
            suffix="ios-search"
            v-model="keyword"
            @on-search="searchhand()"
            search
            placeholder="请输入断面关键字"
            style="width: auto;margin-top:-13px;"
          />
        </i-col>
      </Row>
    </Card>
    <Card style="margin-top:5px;">
      <Button type="error" @click="delData('deleteDirectoryById')">批量删除</Button>
      <Table
        border
        class="tabbottom"
        :columns="columns"
        :data="list"
        @on-selection-change="changeSelection"
      >
        <template slot-scope="{ row }" slot="action">
          <Button type="primary" size="small" style="margin-right: 5px" @click="showdetail(row)">编辑</Button>
          <Button type="error" size="small" @click="remove(row)">删除</Button>
        </template>
      </Table>
      <div style="text-align:center">
        <br />
        <Page :total="pageTotal" :current="page" @on-change="changePage" :page-size="limit"></Page>
      </div>
    </Card>
  </div>
</template>
<script>
import $_axios from "@/prjapiall/directoryapi";
import { global } from "../../globals/global";
export default {
  data() {
    return {
      path: [],
      chose: "搜索断面",
      columns: [
        {
          type: "selection",
          width: 60,
          align: "center"
        },
        {
          title: "断面名称",
          key: "directoryName"
        },
        {
          title: "断面编号",
          key: "id"
        },
        {
          title: "断面说明",
          key: "directoryDesc",
          render(h, params) {
            return h(
              "span",
              params.directoryDesc ? params.directoryDesc : "无"
            );
          }
        },
        {
          title: "操作",
          slot: "action"
        }
      ],
      selectionId: [],
      pageTotal: 10, // 数据总条数
      page: 1, // 页码
      limit: 10, // 每页显示条数,
      list: [],
      keyword: ""
    };
  },
  methods: {
    showwhat($event) {
      if ($event == "断面属性") {
        this.$router.push({
          name: "directory_attar"
        });
      }
    },
    changePage(val) {
      this.page = val;
    },
    changeSelection(selection) {
      this.selectionId = [];
      selection.map(item => {
        this.selectionId.push(item.id);
      });
    },
    remove({ id }) {
      this.$Modal.confirm({
        render: h => {
          return h("span", "确定要删除吗这一项吗");
        },
        onOk: () => {
          this.delData("deleteDirectoryById", id);
          this.initthings();
        }
      });
    },
    delData(e, id) {
      let ids = [];
      if (id) {
        // 删除一个
        ids.push(id);
        $_axios("POST", e, ids).then(({ data }) => {
          if (data.msg == "success") {
            this.initthings();
            this.path = [];
            this.path.push(localStorage.getItem("clientId"));
            global.$emit("position", this.path);
            this.$Message.info("删除成功");
          } else {
            this.$Message.error(data.msg);
          }
        });
      } else {
        // 删除选中的所有
        if (this.selectionId.length > 0) {
          ids = this.selectionId;
          this.$Modal.confirm({
            render: h => {
              return h("span", "确定要批量删除吗");
            },
            onOk: () => {
              $_axios("POST", e, ids).then(({ data }) => {
                if (data.msg == "success") {
                  this.initthings();
                  this.path = [];
                  this.path.push(localStorage.getItem("clientId"));
                  global.$emit("position", this.path);
                  this.$Message.info("删除成功");
                } else {
                  this.$Message.error(data.msg);
                }
              });
            }
          });
        } else {
          this.$Message.error("没有要删除的角色");
        }
      }
    },
    initthings() {
      $_axios("POST", "queryDirectoryByFilter", {
        page: this.page + "",
        limit: this.limit + ""
      }).then(({ data }) => {
        if (data.code == 0) {
          const { pageSize, totalCount, totalPage, currPage, list } = data.page;
          this.list = list;
          this.pageTotal = totalCount;
          this.limit = pageSize;
        }
      });
    },
    showdetail($evnt) {
      this.path.push($evnt.clientId, $evnt.projectId, $evnt.id);
      global.$emit("position", this.path);
      this.$router.push({
        name: "directory_attar",
        params: {
          directory: $evnt.id
        },
        query: {
          clientId: $evnt.clientId,
          directoryid: $evnt.id,
          directoryname: $evnt.directoryName,
          directorynum: $evnt.id || "",
          projectId: $evnt.projectId
        }
      });
    },
    searchhand() {
      if (this.keyword) {
        let self = this;
        $_axios("POST", "fuzzyQueryDirectoryList", {
          keyword: this.keyword
        }).then(({ data }) => {
          if (data.code == 0) {
            const {
              pageSize,
              totalCount,
              totalPage,
              currPage,
              list
            } = data.page;
            if (list.length) {
              for (let k in data.page) {
                this[k] = data.page[k];
              }
              this.$Message.info("搜索成功");
            } else {
              this.$Message.info("未匹配到对应条件~~");
            }
          }
        });
      }
    }
  },
  watch: {
    page: {
      handler() {
        this.initthings();
      },
      deep: true
    },
    keyword() {
      !this.keyword ? this.initthings() : this.searchhand();
    }
  },
  mounted() {
    // this.initthings()
    this.keyword = this.$route.query.keyword;
    return;
    if (this.keyword === undefined) {
      this.initthings();
    } else {
      this.searchProject();
    }
  }
};
</script>

<style lang="less" scoped>
.tabbottom {
  margin-top: 5px;
}
</style>